export type ComponentTheme = 'clinical' | 'consumer'

export function getTheme(src?: string): ComponentTheme {
  const { searchParams } = new URL(src ?? document.location.href)

  return searchParams.get('theme') === 'clinical' ? 'clinical' : 'consumer'
}
